<template>
  <div>
    <div id="_div" class="w-100 px-5 py-4">
      <div id="Titulo_div">
        <h1>Registro de Quejas</h1>

      </div>
      <div style="display: flex">
        <div class="col-12 padding-div-low">
          <div class="area">
            <div class="row">
              <div class="col-3"><span>Consecutivo:</span></div>
              <div class="col-3"><span>Fecha de Radicación:</span></div>
              <div class="col-3"><span>Fecha de Sentencia:</span></div>
              <div class="col-3"><span>Sentido de la Sentencia:</span></div>
            </div>
            <div class="row new-row">
              <div class="col-3"><input type="text" class="form-control" placeholder="####/####" v-model="consecutivo" @keypress="validarNumero" maxlength="9" id="consecutivo" /></div>
              <div class="col-3"><input type="date" class="form-control" v-model="fechaRadicacion" /></div>
              <div class="col-3"><input type="date" class="form-control" v-model="fechaSentencia" :disabled="parametros_TipoDeSentidoDeSentencia.tipoDeSentidoDeSentenciaId === 8"/></div>
              <div class="col-3">
                <C003TiposDeSentidoDeSentencia v-on:valorParaElPadre="cambioTipoDeSentidoDeSentencia"
                                               :prefijo="enumeraciones.etiquetasDeHTML.Select"
                                               :tipo="enumeraciones.tiposDeSelect.Seleccione"
                                               :idDelInput="'catalogoTipoDeSentidoDeSentencia'"
                                               :parametros="parametros_TipoDeSentidoDeSentencia"
                                               :valorDefinido="parametros_TipoDeSentidoDeSentencia.valorDefinido">
                </C003TiposDeSentidoDeSentencia>
              </div>
            </div>
            <div class="row new-row">
              <div class="col-2 col-sin-padding">
                <input type="button" class="form-control pestanaInvolucrados pestanaActiva" value="Quejosos" @click="cambiarPestana" />
              </div>
              <div class="col-2 col-sin-padding">
                <input type="button" class="form-control pestanaInvolucrados" value="Demandados" @click="cambiarPestana" />
              </div>
            </div>
            <div class="row new-row">
              <div class="col-3"><span>Nombre:</span></div>
              <div class="col-3"><span>Apellido Paterno:</span></div>
              <div class="col-3"><span>Apellido Materno:</span></div>
            </div>
            <div class="row">
              <div class="col-3"><input type="text" class="form-control" v-model="nombreInvolucrado" id="nombreInvolucrado" v-on:keyup.enter="agregarInvolucrado" /></div>
              <div class="col-3"><input type="text" class="form-control" v-model="apellidoPaternoInvolucrado" v-on:keyup.enter="agregarInvolucrado" /></div>
              <div class="col-3"><input type="text" class="form-control" v-model="apellidoMaternoInvolucrado" v-on:keyup.enter="agregarInvolucrado" /></div>
              <div class="col-3" v-if="estatusTipoInvolucrado == 1"><input type="button" class="form-control" value="Agregar" @click="agregarInvolucrado" /></div>
            </div>
            <template v-if="estatusTipoInvolucrado == 2">
              <div class="row new-row">
                <div class="col-9"><span>Cargo:</span></div>
              </div>
              <div class="row" >
                <div class="col-9"><input type="text" class="form-control" v-model="cargoInvolucrado" v-on:keyup.enter="agregarInvolucrado" /></div>
                <div class="col-3"><input type="button" class="form-control" value="Agregar" @click="agregarInvolucrado" /></div>
              </div>
            </template>
            <div class="row new-row">
              <div class="col-12">
                <table class="table table-striped table-light table-hover" id="tablaInvolucrados">
                  <thead class="thead-dark">
                    <tr>
                      <th class="col-9">Nombre</th>
                      <th class="col-3">Acciones</th>
                    </tr>
                  </thead>
                  <tbody class="text-dark">
                    <tr v-for="(involucrado, indice) in involucrados[estatusTipoInvolucrado-1]" v-bind:key="indice">
                      <td>
                        {{obtenerNombreCompleto(involucrado.nombre,involucrado.apellidoPaterno,involucrado.apellidoMaterno)}}
                        <span v-if="estatusTipoInvolucrado === 2">: {{involucrado.cargo}}</span>

                      </td>
                      <td> <i class="fas fa-trash fa-lg" title="Quitar Involucrado" @click="quitarInvolucrado(indice, involucrado.involucradoId)" /> </td>
                    </tr>
                    <tr v-if="involucrados[estatusTipoInvolucrado-1].length == 0"><td colspan="2">No se han agregado involucrados.</td></tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="row new-row">
              <div class="col-3"><span>Sanción:</span></div>
            </div>
            <div class="row">
              <div class="col-9">
                <input type="text" class="form-control" v-model="sancion" :disabled="parametros_TipoDeSentidoDeSentencia.tipoDeSentidoDeSentenciaId === 8"/>
              </div>
              <div class="col-3">
                <input type="button" class="form-control" value="Guardar" :disabled="deshabilitarBotonGuardar" @click="finalizar" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import enumeraciones from '@/../static/js/enumeraciones'
  import catalogos from '@/../static/js/catalogos'
  import api from '@/../static/js/api'
  import comun from '@/../static/js/comun'
  import axios from 'axios'
  import store from '@/store/index'
  export default {
    data() {
      return {
        enumeraciones,
        catalogos,
        parametros_TipoDeSentidoDeSentencia: {
          valorDefinido: -1,
          tipoDeSentidoDeSentenciaId: null
        },
        consecutivo: "",
        fechaRadicacion: null,
        fechaSentencia: null,
        estatusTipoInvolucrado: 1,
        nombreInvolucrado: "",
        apellidoPaternoInvolucrado: "",
        apellidoMaternoInvolucrado: "",
        cargoInvolucrado: "",
        involucrados: [[], []],
        involucradosEliminadosId: [],
        sancion: "",
        numeroFilasPagina: 5
      }
    },
    props: {
      quejaAdministrativaId: Number,
    },
    mounted() {
      document.querySelector('#consecutivo').focus();
      if (this.quejaAdministrativaId)
        this.obtenerQuejaAdministrativa();
    },
    components: {
      C003TiposDeSentidoDeSentencia: catalogos.SIQA.C003TiposDeSentidoDeSentencia,
    },
    methods: {
      finalizar() {
        if (this.quejaAdministrativaId)
          this.actualizarQueja();
        else
          this.registrarQueja();
      },
      registrarQueja: function () { //Retorna una lista de citas 'Aceptadas'
        var peticion = {
          "involucrados": this.involucrados,
          "consecutivo": this.consecutivo,
          "fechaRadicacion": this.fechaRadicacion,
          "fechaSentencia": (this.parametros_TipoDeSentidoDeSentencia.tipoDeSentidoDeSentenciaId !== 8)? this.fechaSentencia : null,
          "tipoDeSentidoDeSentencia": this.parametros_TipoDeSentidoDeSentencia.tipoDeSentidoDeSentenciaId,
          "sancion": (this.parametros_TipoDeSentidoDeSentencia.tipoDeSentidoDeSentenciaId !== 8) ? this.sancion : ""
        };
        comun.SeEstaCargandoInformacion(true);
        axios.post(api.conexion + api.SIQA.funciones.RegistrarQueja, peticion, comun.CrearElHeaderDeAutorizacion(store.state.Login_AutorizacionOriginal)).then(response => {
          comun.SeEstaCargandoInformacion(true);
          if (response.data.SiHayError == false) {//En caso de que la petición sea exitosa
            this.resetearData();
            comun.mensajeDeAlerta(`${response.data.Satisfactorio}.\nNúmero de queja administrativa: ${response.data.QuejaAdministrativaId}`, null, null);
            //this.$emit("valorParaElPadre", [evento, this.TiposDeSentidosDeSentencia[evento.target.selectedIndex - 1]]);
          }
          else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null)
          }
          comun.SeEstaCargandoInformacion(false);
        }).catch(e => {
          console.error("encontre un error " + e);
          comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null)
          comun.SeEstaCargandoInformacion(false);
        });
      },
      actualizarQueja: function () { //Retorna una lista de citas 'Aceptadas'
        var peticion = {
          "involucrados": this.involucrados,
          "consecutivo": this.consecutivo,
          "fechaRadicacion": this.fechaRadicacion,
          "fechaSentencia": (this.parametros_TipoDeSentidoDeSentencia.tipoDeSentidoDeSentenciaId !== 8) ? this.fechaSentencia : null,
          "tipoDeSentidoDeSentencia": this.parametros_TipoDeSentidoDeSentencia.tipoDeSentidoDeSentenciaId,
          "sancion": (this.parametros_TipoDeSentidoDeSentencia.tipoDeSentidoDeSentenciaId !== 8) ? this.sancion : "",
          "quejaAdministrativaId": this.quejaAdministrativaId,
          "involucradosEliminadosId": this.involucradosEliminadosId
        };
        comun.SeEstaCargandoInformacion(true);
        axios.post(api.conexion + api.SIQA.funciones.ActualizarQueja, peticion, comun.CrearElHeaderDeAutorizacion(store.state.Login_AutorizacionOriginal)).then(response => {
          comun.SeEstaCargandoInformacion(true);
          if (response.data.SiHayError == false) {//En caso de que la petición sea exitosa
            this.resetearData();
            comun.mensajeDeAlerta(`${response.data.Satisfactorio}`, null, null);
          }
          else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null)
          }
          comun.SeEstaCargandoInformacion(false);
        }).catch(e => {
          console.error("encontre un error " + e);
          comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null)
          comun.SeEstaCargandoInformacion(false);
        });
      },
      obtenerQuejaAdministrativa: function () { //Retorna una lista de citas 'Aceptadas'
        var peticion = {
          "quejaAdministrativaId": this.quejaAdministrativaId,
          
        };
        comun.SeEstaCargandoInformacion(true);
        axios.post(api.conexion + api.SIQA.funciones.ObtenerQuejaAdministrativa, peticion, comun.CrearElHeaderDeAutorizacion(store.state.Login_AutorizacionOriginal)).then(response => {
          comun.SeEstaCargandoInformacion(true);
          if (response.data.SiHayError == false) {//En caso de que la petición sea exitosa
            this.cargarDatosFormulario(response.data.quejaAdministrativa);
          }
          else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null)
          }
          comun.SeEstaCargandoInformacion(false);
        }).catch(e => {
          console.error("encontre un error " + e);
          comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null)
          comun.SeEstaCargandoInformacion(false);
        });
      },
      cargarDatosFormulario(quejaAdministrativa) {
        //console.log(quejaAdministrativa)
        this.consecutivo = quejaAdministrativa.consecutivo;
        this.fechaRadicacion = quejaAdministrativa.fechaDeRadicacion.substring(0, 10);
        this.fechaSentencia = (quejaAdministrativa.fechaDeSentencia)? quejaAdministrativa.fechaDeSentencia.substring(0, 10) : null;
        this.parametros_TipoDeSentidoDeSentencia.tipoDeSentidoDeSentenciaId = quejaAdministrativa.sentidoDeSentenciaId;
        $('#catalogoTipoDeSentidoDeSentencia').val(quejaAdministrativa.sentidoDeSentenciaId);
        for (let qa_inv of quejaAdministrativa.quejaAdministrativa_involucrados)
        {
          const involucrado = this.constructorInvolucrado(qa_inv.involucrado.nombre, qa_inv.involucrado.apellidoPaterno, qa_inv.involucrado.apellidoMaterno,qa_inv.involucrado.cargo, qa_inv.tipoDeInvolucradoId, qa_inv.involucrado.involucradoId);
          this.involucrados[qa_inv.tipoDeInvolucradoId - 1].push(involucrado);
        }
        this.sancion = quejaAdministrativa.sancion;
      },
      cambiarPestana: function (event) {
        console.log(event);
        if(!event.target.classList.contains("pestanaActiva")){
        const pestanas = document.querySelectorAll('.col-sin-padding > input[type=button]');
        pestanas.forEach(pestana => pestana.classList.remove('pestanaActiva'));
        event.target.classList.add('pestanaActiva');
        this.estatusTipoInvolucrado = (this.estatusTipoInvolucrado === 1) ? 2 : 1;
        this.paginarTabla('tablaInvolucrados');
        document.querySelector('#nombreInvolucrado').focus();
        }
      },
      cambioTipoDeSentidoDeSentencia(datos) { //Administra los cambios en el componente de Área
        catalogos
        this.parametros_TipoDeSentidoDeSentencia.tipoDeSentidoDeSentenciaId = parseInt(datos[0].target.value)
      },
      constructorInvolucrado(nombre, apellidoPaterno, apellidoMaterno, cargo, tipoInvolucradoId, involucradoId = 0) {
        const nombreInvolucradoLimpio = nombre;
        const apellidoPaternoInvolucradoLimpio = apellidoPaterno;
        const apellidoMaternoInvolucradoLimpio = apellidoMaterno;
        const cargoInvolucradoLimpio = cargo;
        const nuevoInvolucrado = {
          involucradoId: involucradoId,
          nombre: nombreInvolucradoLimpio,
          apellidoPaterno: apellidoPaternoInvolucradoLimpio,
          apellidoMaterno: apellidoMaternoInvolucradoLimpio,
          activo: 1,
          cargo: (tipoInvolucradoId == 1) ? "" : cargoInvolucradoLimpio
        }
        return nuevoInvolucrado;
      },
      agregarInvolucrado(event) {
        const nuevoInvolucrado = this.constructorInvolucrado(this.nombreInvolucrado, this.apellidoPaternoInvolucrado, this.apellidoMaternoInvolucrado, this.cargoInvolucrado, this.estatusTipoInvolucrado);
        if (!nuevoInvolucrado.nombre || (!nuevoInvolucrado.apellidoPaterno && !nuevoInvolucrado.apellidoMaterno) || (!nuevoInvolucrado.cargo && this.estatusTipoInvolucrado === 2)) { return 0; }
        this.nombreInvolucrado = "";
        this.apellidoPaternoInvolucrado = "";
        this.apellidoMaternoInvolucrado = "";
        this.cargoInvolucrado = "";
        this.involucrados[this.estatusTipoInvolucrado - 1].push(nuevoInvolucrado);
        this.paginarTabla('tablaInvolucrados');
        document.querySelector('#nombreInvolucrado').focus();
      },
      quitarInvolucrado(indice, involucradoId) {
        if (this.quejaAdministrativaId && involucradoId !== 0)
          this.involucradosEliminadosId.push(involucradoId);
        this.involucrados[this.estatusTipoInvolucrado - 1].splice(indice, 1);
        this.paginarTabla('tablaInvolucrados');
      },
      resetearData() {
        this.parametros_TipoDeSentidoDeSentencia.tipoDeSentidoDeSentenciaId = -1;
        $('#catalogoTipoDeSentidoDeSentencia').val(-1);
        this.consecutivo = "";
        this.fechaRadicacion = null;
        this.fechaSentencia = null;
        if (this.estatusTipoInvolucrado === 2) {
          const pestanas = document.querySelectorAll('.col-sin-padding > input[type=button]');
          pestanas.forEach(pestana => pestana.classList.remove('pestanaActiva'));
          pestanas[0].classList.add('pestanaActiva');
          this.estatusTipoInvolucrado = 1;
        }
        this.nombreInvolucrado = "";
        this.apellidoPaternoInvolucrado = "";
        this.apellidoMaternoInvolucrado = "";
        this.involucrados = [[], []];
        this.sancion = "";
        document.querySelector('#consecutivo').focus();
      },
      obtenerNombreCompleto(nombre, apellidoPaterno, apellidoMaterno) {
        return [nombre, apellidoPaterno, apellidoMaterno].filter(palabra => palabra.length > 0).join(' ');
      },
      validarNumero: function ($event) { //valida que el caracter ingresado en el input de expediente sea un número.
        let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
        if ((keyCode < 48 || keyCode > 57)) { // 46 is dot
          $event.preventDefault();
        } else {
          if (this.consecutivo.length == 4) {
            this.consecutivo += "/"
          }
        }
      },
      paginarTabla: function (idTabla) {
        this.$nextTick(() => {
          PaginarTabla(idTabla, this.numeroFilasPagina)
        })
      }
    }, computed: {
      deshabilitarBotonGuardar: function () {
        return (this.parametros_TipoDeSentidoDeSentencia.tipoDeSentidoDeSentenciaId !== 8) ? this.quejaIncompleta || this.quejaSinDatosSentencia : this.quejaIncompleta;
      },
      quejaSinDatosSentencia: function () {
        return !this.fechaSentencia || !this.sancion
      },
      quejaIncompleta: function () {
        return this.consecutivo.length < 9 || !this.fechaRadicacion || this.sentidoDeSentenciaInvalido || this.involucradosVacio
      },
      sentidoDeSentenciaInvalido: function () {
        return !this.parametros_TipoDeSentidoDeSentencia.tipoDeSentidoDeSentenciaId || this.parametros_TipoDeSentidoDeSentencia.tipoDeSentidoDeSentenciaId === -1
      },
      involucradosVacio: function () {
        return this.involucrados[0].length === 0 || this.involucrados[1].length === 0
      }
    },
    created() {

    }
  }
</script>

<style scoped>


  .padding-div-low {
    padding-top: 40px;
  }

  .fas {
    cursor: pointer;
  }

  .new-row {
    margin-top: 20px;
  }

  span {
    font-weight: bold;
  }

  input[type=button] {
    cursor: pointer;
  }

  .col-sin-padding {
    padding: 0;
  }

  .pestanaActiva {
    color: black;
    background-color: white;
    font-weight: bold;
  }
</style>



// WEBPACK FOOTER //
// src/components/SIQA/QuejasAdministrativas/RegistroDeQuejas/RegistroDeQuejas.vue